import { createStyles, makeStyles } from '@hawkins/styles';
export function notificationBadgeStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name for the root of the badge */
        root: {
            alignContent: 'center',
            alignItems: 'center',
            backgroundColor: hawkins.state.backgroundColorHighlightRegular,
            borderRadius: 10,
            color: hawkins.persistent.textColorWhiteRegular,
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
            fontSize: hawkinsVariables.fontSizes.fontSize0,
            fontWeight: hawkinsVariables.fontWeights.fontWeight1,
            height: hawkinsVariables.sizings.size1,
            justifyContent: 'center',
            lineHeight: '1',
            minWidth: hawkinsVariables.sizings.size1,
            padding: "0 ".concat(hawkinsVariables.spacings.space0),
            pointerEvents: 'none',
            position: 'absolute',
            right: 2,
            top: 2,
            zIndex: 1,
        },
        /** Class name to apply to the wrapper element*/
        wrapper: {
            display: 'inline-flex',
            flexShrink: 0,
            position: 'relative',
            alignItems: 'center',
        },
        /** Class name for the dot of the badge */
        dot: {
            height: hawkinsVariables.sizings.size0,
            minWidth: hawkinsVariables.sizings.size0,
            padding: 0,
            right: 6,
            top: 6,
        },
        /** Class name for the dot when compact is true */
        compact: {
            height: 4,
            minWidth: 4,
            right: 2,
            top: 2,
        },
        /** Class name for when the badge is invisible */
        invisible: {
            visibility: 'hidden',
        },
    });
}
export var useNotificationBadgeStyles = makeStyles(notificationBadgeStyles, {
    name: 'Hawkins-NotificationBadge',
});
